module.exports = __webpack_public_path__ + "static/media/ios-film.ca296b3b.svg";